import { Text } from '@cinch-labs/design-system'
import { useAnalytics } from '@cinch-nx/shared-analytics'
import cx from 'classnames'

import { supportContactContent } from '../../data/content'
import { handleTrackingClick } from '../../helpers/helpers'
import styles from './complaints.module.css'

const Complaints = () => {
  const { trackEvent } = useAnalytics()
  const {
    whatsAppHref,
    callCta,
    complaintsHeading1,
    complaintsHeading2,
    complaintsParagraphs1,
    complaintsParagraphs2,
    complaintsAddress,
    complaintsEmailCta,
    pressHeading,
    pressBody,
    pressCta,
  } = supportContactContent

  return (
    <>
      <div className={styles.complaints}>
        <div className={styles.textWrapper}>
          <Text fontSize="m" fontWeight="semibold" className={styles.heading}>
            {complaintsHeading1}
          </Text>
        </div>

        <div
          className={cx(styles.textWrapper, styles.complaintsParagraphsWrapper)}
        >
          {complaintsParagraphs1 &&
            complaintsParagraphs1.map((paragraph: string, index: number) => (
              <p className={styles.paragraph} key={index}>
                {paragraph}
              </p>
            ))}
        </div>

        <table className={styles.complaintsContactTable}>
          <tbody>
            <tr>
              <td>
                <Text fontSize="s" fontWeight="semibold">
                  Phone:
                </Text>
              </td>
              <td>
                <a
                  href={`tel:${callCta}`}
                  aria-label={callCta}
                  className={styles.link}
                  onClick={() =>
                    handleTrackingClick(trackEvent, {
                      eventName: 'Support - complaints phone click',
                      label: callCta,
                      category: 'phone',
                    })
                  }
                >
                  {callCta}
                </a>
              </td>
            </tr>
            <tr>
              <td>
                <Text fontSize="s" fontWeight="semibold">
                  Email:
                </Text>
              </td>
              <td>
                <a
                  href={`mailto:${complaintsEmailCta}`}
                  aria-label={complaintsEmailCta}
                  className={styles.link}
                  onClick={() =>
                    handleTrackingClick(trackEvent, {
                      eventName: 'Support - complaints email click',
                      label: complaintsEmailCta,
                      category: 'email',
                    })
                  }
                >
                  {complaintsEmailCta}
                </a>
              </td>
            </tr>
            <tr>
              <td>
                <Text fontSize="s" fontWeight="semibold">
                  Live Chat:
                </Text>
              </td>
              <td>
                <a
                  href={whatsAppHref}
                  aria-label={'whatsApp complaints link'}
                  className={styles.link}
                  onClick={() =>
                    handleTrackingClick(trackEvent, {
                      eventName: 'Support - complaints whatsApp click',
                      label: whatsAppHref,
                      category: 'live chat',
                    })
                  }
                >
                  {whatsAppHref}
                </a>
              </td>
            </tr>
            <tr>
              <td>
                <Text fontSize="s" fontWeight="semibold">
                  In Writing:
                </Text>
              </td>
              <td>
                <Text
                  fontSize="s"
                  fontWeight="book"
                  className={styles.complaintsAddress}
                >
                  {complaintsAddress}
                </Text>
              </td>
            </tr>
          </tbody>
        </table>

        <div className={styles.textWrapper}>
          <Text fontSize="m" fontWeight="semibold" className={styles.heading}>
            {complaintsHeading2}
          </Text>
        </div>

        <div
          className={cx(styles.textWrapper, styles.complaintsParagraphsWrapper)}
        >
          {complaintsParagraphs2.map((paragraph, index) => (
            <p
              className={styles.paragraph}
              key={index}
              dangerouslySetInnerHTML={{ __html: paragraph }}
            ></p>
          ))}
        </div>
      </div>

      <div className={styles.press}>
        <div className={styles.textWrapper}>
          <Text fontSize="m" fontWeight="semibold" className={styles.heading}>
            {pressHeading}
          </Text>
        </div>

        <div className={styles.textWrapper}>
          <p className={styles.paragraph}>{pressBody}</p>
        </div>

        <a
          href={`mailto:${pressCta}`}
          aria-label={'press link'}
          className={styles.link}
          onClick={() =>
            handleTrackingClick(trackEvent, {
              eventName: 'Support - complaints press click',
              label: pressCta,
              category: 'email',
            })
          }
        >
          {pressCta}
        </a>
      </div>
    </>
  )
}

export default Complaints
